<template lang="html">
    <div class="goodsList-container">
        <div class="goodsItem" v-for="goods of list" :key="goods.spu_id" @click="onClickItem(goods)">
            <div class="box">
                <div class="goodsImg">
                    <img v-lazy="goods.goods_img" alt="">
                </div>
                <div class="goodsText">
                    <div class="goodsName van-multi-ellipsis--l2">{{goods.goods_name}}</div>
                    <div class="goodsPrice">
                        <span v-if="goods.activity_type !== 0" class="label">
                            <i class="ico ico-icon_97" v-if="goods.activity_type === 1"></i>
                            <i class="ico ico-icon_64" v-else></i>
                        </span>
                        <span class="present_price">￥{{goods.goods_present_price}}</span>
                        <span v-if="goods.activity_type !== 0" class="goods_price">￥{{goods.goods_price}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'GoodsList',
    props: {
        list: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    components: {

    },
    data () {
        return {

        }
    },
    methods: {
        onClickItem (item) {
            this.$emit('onClickItem', item)
        }
    }
}
</script>
<style lang="stylus" scoped>
.goodsList-container
    padding 20px
    box-sizing border-box
    display flex
    flex-flow wrap
    justify-content space-between
    .goodsItem
        width 348px
        box-sizing border-box
        margin-bottom 14px
        height 498px
        overflow hidden
        border-radius 16px
        .box
            background $fcWhite
            .goodsImg
                width 100%
                height 348px
                display flex
                align-items center
                overflow hidden
                img
                    width 100%
            .goodsText
                box-sizing border-box
                padding 21px
                height 150px
                font-size 24px
                .goodsName
                    line-height 1.1
                    height 48px
                    -webkit-box-pack center
                .goodsPrice
                    margin-top 10px
                    display flex
                    align-items center
                    .label
                        margin-right 10px
                        display flex
                        align-items center
                    .present_price
                        font-size 28px
                        color #ff0000
                        margin-right 10px
                        font-weight bold
                    .goods_price
                        font-size 26px
                        color #999999
                        text-decoration line-through
</style>
